import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "default_card_wm elevation-0 px-4 py-3 mb-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "d-flex align-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_icon, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showData = !_ctx.showData)),
                icon: _ctx.showData ? '$fa-chevron-up' : '$fa-chevron-down'
              }, null, 8, ["icon"]),
              _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "ml-4" }, "Informations déclarant", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.showData)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "px-1 py-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.companyName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.declaring.companyName) = $event)),
                      label: "Raison sociale",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.siret,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.declaring.siret) = $event)),
                      label: "SIRET",
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInputSetTruncatedSiret())),
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.ape,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.declaring.ape) = $event)),
                      label: "Code APE",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.closingDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.declaring.closingDate) = $event)),
                      label: "Date de clôture de l'exercice (format JJMM)",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "px-1 py-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.number,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.declaring.number) = $event)),
                      label: "Numéro",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.btq,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.declaring.btq) = $event)),
                      label: "BTQ",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.street,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.declaring.street) = $event)),
                      label: "Voie",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.city,
                      "onUpdate:modelValue": [
                        _cache[9] || (_cache[9] = ($event: any) => ((_ctx.declaring.city) = $event)),
                        _cache[10] || (_cache[10] = ($event: any) => (_ctx.onPostalCodeOrCityChange(_ctx.declaring)))
                      ],
                      label: "Commune",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.postalCode,
                      "onUpdate:modelValue": [
                        _cache[11] || (_cache[11] = ($event: any) => ((_ctx.declaring.postalCode) = $event)),
                        _cache[12] || (_cache[12] = ($event: any) => (_ctx.onPostalCodeOrCityChange(_ctx.declaring)))
                      ],
                      label: "Code postal",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.inseeCode,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.declaring.inseeCode) = $event)),
                      label: "Code Insee commune",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.postOfficeDistributor,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.declaring.postOfficeDistributor) = $event)),
                      label: "Bureau distributeur",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "px-1 py-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.signatoryName,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.declaring.signatoryName) = $event)),
                      label: "Personne à contacter",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.signatoryEmail,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.declaring.signatoryEmail) = $event)),
                      label: "Adresse mail",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "px-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.declaring.signatoryPhone,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.declaring.signatoryPhone) = $event)),
                      label: "Téléphone",
                      outlined: "",
                      "hide-details": "auto",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}